const initLogActivity = {
  logActivities: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterGroupActivityPage: "",
  filterPortalPage: "",
  logGroupActivityFilters: [],
  logActivityPortalFilters: ["All", "Admin", "Chatbot", "IcownicPatch", "UltraOddinary"],
  isFilterLoading: false,
};

export const logActivityReducer = (state = initLogActivity, action: any) => {
  if (action.type === "SET_LOG_ACTIVITY") {
    return {
      ...state,
      logActivities: action.value,
    };
  }
  if (action.type === "SET_LOG_ACTIVITY_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_LOG_ACTIVITY_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_LOG_ACTIVITY_FILTER_PAGE") {
    return {
      ...state,
      filterGroupActivityPage: action.filterGroupActivityPage,
      filterPortalPage: action.filterPortalPage,
    };
  }
  if (action.type === "SET_SEARCH_LOG_ACTIVITY") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_LOG_ACTIVITY_GROUP") {
    return {
      ...state,
      logGroupActivityFilters: [{ group_activity: "All" }, ...action.value],
    };
  }
  if (action.type === "SET_FILTER_LOADING") {
    return {
      ...state,
      isFilterLoading: action.value,
    };
  }
  return state;
};
